import { useQuery } from '@tanstack/react-query';
import { getCalendarDays, loadCalendarDaysLocalCache } from '../../services/calendarService';
import { schoolKeys } from '../keys';
import { cacheOnlyQueryOptions } from './cacheOnlyQuery';
import { lsInitialDataOptions } from './lsInitialData';

export type UseCalendarDaysQueryParams = {
  workspaceId: string;
  from: string;
  to: string;
  enabled?: boolean;
  cacheOnly?: boolean;
};

export function useCalendarDaysQuery(params: UseCalendarDaysQueryParams) {
  const { workspaceId, from, to, enabled = true, cacheOnly = false } = params;
  const ls = loadCalendarDaysLocalCache(workspaceId, from, to);

  return useQuery({
    queryKey: schoolKeys.calendarDays(workspaceId, from, to),
    enabled: enabled && !!workspaceId.trim() && !!from.trim() && !!to.trim(),
    ...lsInitialDataOptions(ls.found, ls.rows),
    ...cacheOnlyQueryOptions(cacheOnly),
    queryFn: () => getCalendarDays(workspaceId, from, to),
  });
}
